<template lang="pug">
	#main-page(v-on:scroll='handleScroll')
		slot(ref="principal")
</template>

<script>
export default {

	name: 'MainPage',
	props: {
		div: String
	},

	methods: {

		dataPesquisa(flag) {

			this.$emit('dataPesquisa', flag)

		},

		handleScroll: function(event) {

			if(this.$router.currentRoute.name === 'Principal') {

				if(event.target.scrollTop > 0) {

					this.$emit('navBar', true)

				} else {

					this.$emit('navBar', false)

				}

			}

		}
	}

}
</script>



// WEBPACK FOOTER //
// src/components/layouts/MainPage.vue